import { faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"

const Addition = ({id, addition, changeAddition }) =>{
    const [text, setText] = useState(addition?.text || '')
    // const [type, setType] = useState(addition.type)
    const [required, setRequired] = useState(addition?.required||false)
    const [order, setOrder] = useState(addition?.order || 0)
    const [language, setLanguage] = useState(addition?.language || "javascript")
    const [highlight, setHighlight] = useState(addition?.highlight || true)

    useEffect(()=>{
        changeAddition(id, {_id:id,text,required,order, language, highlight})
    },[text,required,order,id, language, highlight])
    // const options = ACTION_TYPES.map(type => {
    //     return (
    //         <option
    //             key={type}
    //             value={type}
    //         > {type}</option >
    //     )
    // })
    return (
<div className="addition-panel">

<button className="icon-button" type="button" onClick={()=>changeAddition(id, null)}>
<FontAwesomeIcon icon={faTrashCan} />
 </button>
<label className="form__label" htmlFor={`action-text-${id}`}>
                    Text: </label>
               
                 <input type="text" id={`action-text-${id}`} 
                value={text} onChange={(e)=>setText(e.target.value)}
                className={`form__input ${!text && 'form__input--incomplete'}` }
                maxLength={30}
                 />
                {/* <div  className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="action-type">
                            TYPE:</label>
                        <select
                            id="action-type"
                            name="type"
                            className={`form__input`}

                            value={type}
                            onChange={(e)=>setType(e.target.value)}
                        >
                            {options}
                        </select>
                </div> */}
                <div className="form-input-container">
                  <label className="form__label" htmlFor={`action-order-${id}`}>
                    Order:</label>
                <input
                    className={`form__input `}
                    id={`action-order-${id}`}
                    name="order"
                    type="text"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                />
                </div>

                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor={`action-required-${id}`}>
                           Required:
                            <input
                                className="form__checkbox"
                                id={`action-required-${id}`}
                                name="required"
                                type="checkbox"
                                checked={required}
                                onChange={(e)=>setRequired( prev => !prev)}
                            />
                        </label>

                        
                    </div>                   
                </div>
                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor={`action-highlight-${id}`}>
                           Highlight:
                            <input
                                className="form__checkbox"
                                id={`action-highlight-${id}`}
                                name="highlight"
                                type="checkbox"
                                checked={highlight}
                                onChange={(e)=>setHighlight( prev => !prev)}
                            />
                        </label>
{highlight && <select name="language"  id={`action-language-${id}`} value={language} onChange={(e)=>setLanguage(e.target.value)}>
                            <option ></option>
                                <option value={"javascript"} >JS</option>
                                <option value={"html"} >HTML</option>
                                <option value={"css"} >CSS</option>
                           </select>
}

                        
                    </div>                   
                </div>
               
               
</div>
    )
}
export default Addition